import { css } from "@emotion/css";
import type { FeatureCollection, Geometry } from "geojson";
import { type Properties } from "signlets";
import { effect, signal } from "signlets";

import { setWorld } from "../context";
import type { Bounds, Drop, Mode, State } from "../model";
import { createWorld } from "../world";

const style = css`
  width: 100vw;
  height: 100vh;
  cursor: pointer;
  opacity: 0;
  animation: fade-in 1s ease-out 2s forwards;

  @keyframes fade-in {
    to {
      opacity: 1;
    }
  }
`;

export type WorldProps = {
  state: State | undefined;
  drop: Drop;
  mode: Mode;
  bounds: Bounds | undefined;
  overlay: FeatureCollection<Geometry> | undefined;
  onChangeDrop: (_: Partial<Drop>) => void;
  onDone: () => void;
};

export const World = (properties: Properties<WorldProps>) => {
  const [canvas, setCanvas] = signal<HTMLCanvasElement | undefined>(undefined);

  effect(() => {
    const element = canvas();
    if (!element) return;

    const world = createWorld(element, properties);
    void world.then(setWorld);

    return async () => (await world).dispose();
  });

  return <canvas ref={setCanvas} class={style} />;
};
